import { IBarcodeService, IBarcodeServiceStatus } from "../abstraction";
import { KEvent } from "../core/utils";
import { dispatcher } from "../Karma";

export class BarCodeService implements IBarcodeService {
    private barCodeData: string = "";
    private lastBarCode: string = "";
    private timeOutHdlr: any;
    private scanInProgress: boolean = false;

    public Prefix: string = "";
    public Suffix: string = "";

    private barCodeFIFO: string[] = [];
    private interval: number = 180;
    private aliveCount: number = 0;

    private isActive: boolean = false;

    constructor() {
        console.log("Starting bar code service");

        try {
            setInterval(() => {
                this.aliveCount += this.interval;

                // TODO: Voir pour supprimer cette r�f�rence � dispatcher qui n'a rien � faire dans la lecture des codes barres.

                if (dispatcher.RequestCounter == 0) {
                    if (this.barCodeFIFO.length > 0) {
                        this.OnBarCodeReceived.trigger(this.barCodeFIFO.shift());
                    }
                }

                if (this.aliveCount > 1000) {
                    this.aliveCount = 0;
                    this.AliveSignal.trigger({
                        lastBarCode: this.lastBarCode,
                        prefix: this.Prefix,
                        suffix: this.Suffix,
                        scanInProgress: this.scanInProgress,
                        awaitingScans: this.barCodeFIFO.length, 
                        isActive: this.isActive,
                    });
                }

            }, this.interval);


            document.onkeypress = (ev) => {
                if ((this.Prefix == "") || (this.Prefix == undefined)) this.Prefix = "[";
                if ((this.Suffix == "") || (this.Suffix == undefined)) this.Suffix = "]";

                // Si la lecture code barre est coup�e
                if (!this.isActive) {
                    // on regarde si c'est un pr�fixe ou suffixe
                    if ((ev.charCode == this.Prefix.charCodeAt(0)) || (ev.charCode == this.Suffix.charCodeAt(0))) {
                        // si oui, on interrompt la transmission de l'�v�nement, ils seront donc ignor�s
                        ev.cancelBubble = true;
                        ev.preventDefault();
                        ev.stopPropagation();
                    }
                    return;
                }
  
                if (ev.charCode == this.Prefix.charCodeAt(0)) {

                    if (!this.scanInProgress) {
                        // D�marrage d�tection de code barre
                        this.barCodeData = "";
                        this.scanInProgress = true;

                        ev.cancelBubble = true;
						ev.preventDefault();
						ev.stopPropagation();
                        // On d�finit un time out
                        // si on a pas quitt� le mode r�ception au bout de 500ms, on r�initialise
                        clearTimeout(this.timeOutHdlr);

                        this.timeOutHdlr = setTimeout(() => {
                            this.barCodeData = "";
                            this.scanInProgress = false;
                        }, 2000);

                        return;
                    }
                }

                if (!this.scanInProgress) return;

                ev.cancelBubble = true;
                ev.preventDefault();
				ev.stopPropagation();
                // D�tection de tag de fin -> D�clencher un bel �v�nement il faut
                if (ev.charCode == this.Suffix.charCodeAt(0)) {
                    this.scanInProgress = false;
                    // IL faut trouver pourquoi certain codes barres avaient un 5 intempestifs
                    //if (this.barCodeData.startsWith("5")) this.barCodeData = this.barCodeData.slice(1)
                    clearTimeout(this.timeOutHdlr);

                    console.log(`[CB] : ${this.barCodeData}`)

                    // Adding bar code to FIFO
                    this.lastBarCode = this.barCodeData;
                    this.barCodeFIFO.push(this.barCodeData);
                    this.barCodeData = "";
                    return;
                }

                this.barCodeData = this.barCodeData + ev.key;
                return;
            }
        }
        catch (err) {
            console.log(`[CB] - OnKeypress error`)
            console.error(err);
            this.scanInProgress = false;
            clearTimeout(this.timeOutHdlr);
        }
    }

    public StartStop():void {
        this.isActive = !this.isActive;
    }

    public Start(): void {
        console.log("Barcode service is now listening");
        this.isActive = true;
    }

    public Stop(): void {
        console.log("Barcode service is now OFF");
        this.isActive = false;
    }

    public SimulateBarCode(barcode: string): void {
		this.OnBarCodeReceived.trigger(barcode);
	}

    private _OnBarCodeReceived: KEvent<string> = new KEvent<string>();
    public get OnBarCodeReceived(): KEvent<string> { return this._OnBarCodeReceived; }

    private _AliveSignal: KEvent<IBarcodeServiceStatus> = new KEvent<IBarcodeServiceStatus>();
    public get AliveSignal(): KEvent<IBarcodeServiceStatus> { return this._AliveSignal; }

}

